import { render, staticRenderFns } from "./JournalRow.vue?vue&type=template&id=900566fa&scoped=true"
import script from "./JournalRow.vue?vue&type=script&lang=js"
export * from "./JournalRow.vue?vue&type=script&lang=js"
import style0 from "./JournalRow.vue?vue&type=style&index=0&id=900566fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900566fa",
  null
  
)

export default component.exports